import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Country } from '@app/shared/models/country';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VatService {

  headers = new HttpHeaders().set('Authorization', 'true');

  constructor(private http: HttpClient) { }

  listCountries(): Observable<{ country: Country[] }> {
    return this.http.get<{ country: Country[] }>('service:vat' + '/countries', { headers: this.headers });
  }
}
